import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Shop = () => {
    const navigate = useNavigate()
    
    useEffect(() => {
        // Redirigir automáticamente a la página de categorías
        navigate('/Shop/categories')
    }, [navigate])

    return null
}

export default Shop